export class TypeSignature {
  public static readonly ANYTHING = 10;
  public static readonly ELECTRONIC = 0;
  public static readonly DIGITAL = 1;
  public static readonly CLOUD = 2;
  public static readonly REMOTE = 3;
}
